import { jsonDictionary } from 'integrations/common/dictionary';
import { IntegrationInitialState } from 'integrations/common/initialStateTypes';
import { buildInitialTermsState } from 'integrations/common/streams/integrationTermsDictionary/initialState';

export const initialState: IntegrationInitialState = {
  activeIntegration: {
    integrationId: 'json-importer',
    integrationMappingParams: {
      mapColumnsBy: 'sourceFieldName',
      mapTablesBy: 'index',
    },
  },
  termsDictionary: buildInitialTermsState(jsonDictionary),
};
